import { z } from 'zod';
import { optionalText } from '../common.js';
/**
 * Auftragsablauf (KON-172, siehe docs/auftragsmanagement.md): Die Auftragsabwicklung führt eine Anfrage über Angebot und Nachfassen zum verbindlichen Auftrag und übergibt ihn mit einem
 * Hinweis an das Personalmanagement. Dieses plant die Umsetzung bis zum Ende (Aufgaben, Mitarbeiter, Fahrzeuge), schließt die Planung ab oder gibt den Auftrag mit einer Frage zurück.
 */
export const handOverOrderInput = z.object({ note: optionalText(2000) }).strict();
export const returnOrderInput = z.object({ reason: z.string().trim().min(2, 'Bitte nennen Sie den Grund oder die Frage').max(2000) }).strict();
/** Spalten des Auftragscockpits, von der Anfrage bis zur Abrechnung */
export const PIPELINE_STAGES = ['inquiry', 'offer', 'preparing', 'handed_over', 'planned', 'in_progress', 'to_invoice'];
export const PIPELINE_STAGE_LABELS = {
    inquiry: 'Anfragen',
    offer: 'Angebote',
    preparing: 'Auftrag in Vorbereitung',
    handed_over: 'An Personalmanagement übergeben',
    planned: 'Geplant',
    in_progress: 'In Umsetzung',
    to_invoice: 'Abzurechnen',
};
export const PIPELINE_STAGE_HINTS = {
    inquiry: 'Neu oder in Bearbeitung, noch ohne Angebot.',
    offer: 'Entwurf oder versendet, wartet auf die Entscheidung des Kunden.',
    preparing: 'Verbindlich, die Auftragsabwicklung bereitet die Übergabe vor.',
    handed_over: 'Die Planung ist gefragt: Aufgaben, Mitarbeiter und Fahrzeuge.',
    planned: 'Die Planung ist abgeschlossen, die Umsetzung beginnt.',
    in_progress: 'Der Auftrag wird ausgeführt.',
    to_invoice: 'Erledigt, die Rechnung fehlt noch.',
};
/** Einträge je Seite in der gewählten Phase der Auftragsübersicht */
export const PIPELINE_PAGE_SIZE = 20;
/** Auftragsübersicht: Suche über alle Phasen (Nummer, Betreff, Name), gewählte Phase und Seite darin */
export const pipelineQuery = z.object({
    q: z.string().trim().max(100).optional().transform((v) => v || undefined),
    stage: z.enum(PIPELINE_STAGES).optional(),
    page: z.coerce.number().int().min(1).max(10000).default(1),
});
//# sourceMappingURL=orders-flow.js.map